import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { IAIPetProfilePetResponse, IAIPetProfilePetResponseData } from "@/api_framework/api_modals/Pets";

AxiosCurlirize(axios, () => {});
export const useAIPetDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const [aiPetDetails, setAIPetDetails] = useState<IAIPetProfilePetResponseData | null>(null);

  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
   async (user_id?: string) => {
      if (!user_id) {
        setAIPetDetails(null);
        return null;
      }
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IAIPetProfilePetResponseData | null = await axios
          .get(`${CUSTOMER_APIS?.AI_PET_PROFILE_FOR_PET?.baseURL ?? ""}${user_id}`, {
            // params: {
            //   user_id: user_id,
            // },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAIPetProfilePetResponseData | IAIPetProfilePetResponse>) => {
            const payload = "data" in res.data ? res.data.data : res.data;
            if (payload?.user_id) {
              setAIPetDetails(payload);
              return payload;
            } else {
              setAIPetDetails(null);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setAIPetDetails(null);
            captureError(e);
            sendCurl(e.config?.["curlCommand"]);

            return null;
          });
        return response;
      } catch (e: any) {
        setAIPetDetails(null);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute, aiPetDetails };
};
